import React from 'react';
import { getLocale } from 'umi';
import moment from 'moment';
import classNames from 'classnames';
import { cloneDeep } from 'lodash-es';
import { DATA_TYPE_OBJECT, getLanguage } from '@home/utils/common';
import MetricsTrendChart from '@/pages/dashboard/components/MetricsTrendChart';
import { LANGUAGE_EN } from '@home/_config/config';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';
import { useWeekDay } from '@/pages/dashboard/utils/customHook';
import './index.scss';

const KpiCard = (props: any) => {
  const {
    className,
    style,
    apiDataKey,
    filter: propsFilter,
    timeType,
    trendConfig,
    defaultAvtive = 1,
    kpiConfig = {
      nameEn: 'KPI',
      nameCn: 'KPI',
      metricKey: 'profit_kpi',
      formatRule: 'bmk00',
    },
    showConfig = {
      showEye: true,
      showLineChart: true,
      showTable: true,
      showDownloadTable: true,
      showBubbleTitle: true,
    },
    isSplit = true,
    isReverse = true,
    bubbleTimeType = 'StudioDay',
    labelPosition = 'middle',
    formatterFunc: toolTipFunc,
    ...restProps
  } = props || {};
  const filter = cloneDeep(propsFilter);
  const { getWeekDayStr } = useWeekDay();
  const isEN = getLocale() === LANGUAGE_EN;
  const { date_type: dataType } = filter;
  const { data, loading, errorMsg } = props?.data?.[apiDataKey] || {};
  const { card_list: cardList, trend_list: trendList } = data || {};
  const kpiName = getLanguage(isEN, kpiConfig?.nameEn, kpiConfig?.nameCn);
  const kpiData = cardList?.find((v: { metrics_name: any; }) => v?.metrics_name === kpiConfig?.metricKey) || cardList?.[0];
  const kpiValue = kpiData?.value - 0 || "";
  // 根据配置组装对应DodData
  const selectedDataField = DATA_TYPE_OBJECT[dataType] || 'Day';
  const componentMetrics = [trendConfig?.[selectedDataField] || {}];
  if (timeType) {
    filter.timeType = timeType;
  }

  const formatterFunc = (param: any, { bubbleMetrics, showBubbleTitle, bubbleTitle }: any) => {
    // 过滤KPI折线
    const params = param?.filter((v: { seriesName: string; }) => v?.seriesName !== 'COMMON_KPI');
    const date = moment(params?.[0]?.axisValue).format(timeType === 'Month' ? 'YYYY-MM' : 'YYYY-MM-DD');
    const data: any = [];
    const splitData: any = [];
    params?.forEach((item: { seriesName: any; axisValue: any; value: number; color: any; }, index: number) => {
      const { seriesName, value, color } = item || {};
      const metric = bubbleMetrics?.find((v: { name: any; }) => v?.name === seriesName);
      const { formatRule, toolTipName } = metric || componentMetrics?.[index] || {};
      const dataValue = { name: toolTipName, metricsNum: dataFormat({ value, formatRule }), color };
      const beforeTimeMap: any = {
        StudioDay: moment(item.axisValue).subtract(1, 'month').format('YYYY-MM-DD'),
        Day: moment(item.axisValue).subtract(1, 'week').format('YYYY-MM-DD'),
        Week: (() => {
          // 获取当前日期
          const currentDate = moment(item.axisValue);
          // 获取当前日期减去1个月的目标日期
          const targetDate = currentDate.clone().subtract(1, 'month');
          // 如果目标日期的日期部分和当前日期的日期部分相同，则返回目标日期的格式化结果，否则返回 "-"
          return currentDate.date() === targetDate.date() ? targetDate.format('YYYY-MM-DD') : "-";
        })(),
        Month: (() => {
          const currentDate = moment(item.axisValue);
          const targetDate = currentDate.clone().subtract(1, 'year');
          return currentDate.date() === targetDate.date() ? targetDate.format(timeType === 'Day' ? 'YYYY-MM-DD' : 'YYYY-MM') : "-";
        })(),
      };
      const isSameDay = bubbleTimeType === "StudioDay" ? moment(item.axisValue).format('DD') === moment(beforeTimeMap[bubbleTimeType || timeType]).format('DD') : true;
      const now = getWeekDayStr(moment(item.axisValue)?.format(timeType === 'Month' ? 'YYYY-MM' : 'YYYY-MM-DD'), timeType);
      const before = getWeekDayStr(beforeTimeMap[bubbleTimeType || timeType], timeType);
      const title = index === 0 ? now : before;
      isSameDay && splitData.push({ title, data: [dataValue] });
      (isSameDay || index === 0) && data?.push(dataValue);
    });

    return getEchartTooltipText({
      title: date,
      metricsName: showBubbleTitle ? bubbleTitle : undefined,
      data,
      splitData,
      isSplit,
    });
  };
  return (<div className={classNames('dbd-metrics-card__flex', className)} style={style}>
    <MetricsTrendChart
      metricData={trendList}
      componentMetrics={componentMetrics}
      loading={loading}
      error={errorMsg}
      filterVal={filter}
      showConfig={showConfig}
      defaultAvtive={defaultAvtive}
      isReverse={isReverse}
      formatterFunc={toolTipFunc ? (params: any, data: any) => toolTipFunc(params, data) : formatterFunc}
      setOtherConfigFunc={(opt: any) => {
        if (opt?.series) {
          opt.series = [...opt.series, {
            name: "COMMON_KPI",
            type: "line",
            itemStyle: {
              opacity: 0,
            },
            data: [kpiValue],
            markLine: {
              silent: true,
              symbol: ['none', 'none'],
              label: {
                formatter: (params: any) => {
                  const value = dataFormat({ value: params.value, formatRule: kpiConfig?.formatRule });
                  return `${params?.name} ${value}`;
                },
                position: labelPosition,
                color: '#EF5858',
              },
              lineStyle: { color: '#F6C5BB', type: "solid" },
              data: [{ yAxis: kpiValue, name: kpiName }]
            },
          }];
        }
        return opt;
      }}
      {...restProps}
    />
  </div>);
};

export default KpiCard;